import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      position: 'relative',
      display: 'flex',
      flexFlow: 'column nowrap',
    },
    field: {
      '& + &': {
        marginTop: theme.spacing(2),
      },

      '& p:first-child': {
        lineHeight: '140%',
        maxHeight: '400px',
      },
    },
    label: {
      fontWeight: theme.typography.fontWeightSemiBold,
    },
  }),
  { name: 'FormCanvas' }
);
